import { render, staticRenderFns } from "./NoPermissionAlert.vue?vue&type=template&id=5379ed3d"
import script from "./NoPermissionAlert.vue?vue&type=script&lang=js"
export * from "./NoPermissionAlert.vue?vue&type=script&lang=js"
import style0 from "./NoPermissionAlert.vue?vue&type=style&index=0&id=5379ed3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
